import React from "react";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";

const InfoPopover = ({
  title,
  content,
  targetId,
  placement = "right",
  iconClass = "fa-solid fa-circle-info",
}) => {
  if (!targetId || (!title && !content)) return null;

  return (
    <>
      <i
        id={targetId}
        className={`${iconClass} ml-1 text-muted cursor`}
        tabIndex="0"
        role="button"
        aria-label="More information"
      />

      <UncontrolledPopover
        placement={placement}
        target={targetId}
        trigger="hover focus"
        className="custom-tooltip"
      >
        {title && <PopoverHeader>{title}</PopoverHeader>}
        <PopoverBody>{content}</PopoverBody>
      </UncontrolledPopover>
    </>
  );
};

export default InfoPopover;
